import classNames from "classnames";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { PasswordValidation } from "@fidget/common/utils/validatePasswordPolicy";
import styles from "./passwordRules.css";

interface Props {
  okColor: string;
  passwordValidation: PasswordValidation;
  inline?: boolean;
}

export const PasswordRules: React.SFC<Props> = ({ passwordValidation, okColor, inline }) => (
  <div className={classNames({ [styles.inline]: inline })}>
    <p>
      <L10n id={"passwordValidation.ruleDescription"} />
    </p>
    <p className={styles.rules}>
      <span style={{ color: passwordValidation.longEnough ? okColor : "inherit" }}>
        <i className="icon-ok" />
        <L10n id={"passwordValidation.rule1"} />
      </span>
      <span style={{ color: passwordValidation.hasUppercase ? okColor : "inherit" }}>
        <i className="icon-ok" />
        <L10n id={"passwordValidation.rule2"} />
      </span>
      <span style={{ color: passwordValidation.hasOneNumber ? okColor : "inherit" }}>
        <i className="icon-ok" />
        <L10n id={"passwordValidation.rule3"} />
      </span>
    </p>
  </div>
);
